import { render, staticRenderFns } from "./CustomerInfo2.vue?vue&type=template&id=254a6874&scoped=true"
import script from "./CustomerInfo2.vue?vue&type=script&lang=js"
export * from "./CustomerInfo2.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfo2.vue?vue&type=style&index=0&id=254a6874&prod&lang=scss"
import style1 from "./CustomerInfo2.vue?vue&type=style&index=1&id=254a6874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a6874",
  null
  
)

export default component.exports